import React, { createContext, useCallback, useContext, useRef, useState } from 'react';

// Единый механизм уведомлений кабинета.
// Использование: const showToast = useToast(); showToast('Сохранено'); showToast('Ошибка', 'error');

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const idRef = useRef(0);

  const dismiss = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const showToast = useCallback((message, type = 'success') => {
    const id = ++idRef.current;
    setToasts((prev) => [...prev, { id, message, type }]);
    setTimeout(() => dismiss(id), 5000);
  }, [dismiss]);

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2 max-w-sm w-full pointer-events-none" aria-live="polite">
        {toasts.map((t) => (
          <div
            key={t.id}
            role="status"
            className={`pointer-events-auto flex items-start gap-3 bg-white rounded-lg shadow-lg border p-4 ${
              t.type === 'error' ? 'border-red-200' : 'border-green-200'
            }`}
          >
            <svg
              className={`w-5 h-5 mt-0.5 flex-shrink-0 ${t.type === 'error' ? 'text-red-600' : 'text-green-600'}`}
              viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
            >
              {t.type === 'error'
                ? <path d="M12 8v4m0 4h.01M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z" />
                : <path d="M20 6L9 17l-5-5" />}
            </svg>
            <div className="text-sm text-gray-800 whitespace-pre-line flex-1">{t.message}</div>
            <button
              onClick={() => dismiss(t.id)}
              aria-label="Закрыть"
              className="text-gray-400 hover:text-gray-600 flex-shrink-0"
            >
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <path d="M18 6L6 18M6 6l12 12" />
              </svg>
            </button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast должен вызываться внутри <ToastProvider>');
  return ctx;
}
